{
  "save": "Lưu",
  "saving": "Đang lưu...",
  "adding": "Đang thêm...",
  "deleting": "Đang xóa...",
  "cancel": "Hủy",
  "close": "Đóng",
  "confirm": "Xác nhận",
  "unsavedChanges": {
    "title": "Rời trang?",
    "body": "Bạn có thay đổi chưa lưu. Nếu rời đi, các thay đổi sẽ bị mất.",
    "stay": "Ở lại",
    "leave": "Rời đi"
  },
  "add": "Thêm",
  "edit": "Sửa",
  "delete": "Xóa",
  "view": "Xem",
  "search": "Tìm kiếm",
  "refresh": "Làm mới",
  "moreActions": "Thêm thao tác",
  "download": "Tải xuống",
  "upload": "Tải lên",
  "actions": "Thao tác",
  "loading": "Đang tải...",
  "reportGeneratedAt": "Tạo lúc {{time}}",
  "noData": "Không có dữ liệu",
  "supportCode": "Mã hỗ trợ: {{id}}",
  "yes": "Có",
  "no": "Không",
  "profile": "Hồ sơ",
  "settings": "Cài đặt",
  "logout": "Đăng xuất",
  "darkMode": "Chế độ tối",
  "helpCenter": "Trung tâm trợ giúp",
  "reportBug": "Báo cáo lỗi",
  "releaseNotes": "Ghi chú bản phát hành",
  "keyboardShortcuts": "Lối tắt bàn phím",
  "shortcutGroupSearch": "Tìm kiếm & trợ giúp",
  "shortcutGroupNavigate": "Điều hướng",
  "shortcutGroupCreate": "Tạo mới",
  "shortcutGoAppointments": "Lịch hẹn",
  "shortcutGoPatients": "Bệnh nhân",
  "shortcutGoDashboard": "Tổng quan",
  "shortcutGoMyTasks": "Việc của tôi",
  "shortcutGoLeads": "Lead",
  "shortcutGoMessaging": "Hộp thư",
  "shortcutMnemonicGoAppointments": "<mark>G</mark>o to <mark>A</mark>ppointment",
  "shortcutMnemonicGoPatients": "<mark>G</mark>o to <mark>P</mark>atients",
  "shortcutMnemonicGoDashboard": "<mark>G</mark>o <mark>H</mark>ome",
  "shortcutMnemonicGoMyTasks": "<mark>G</mark>o to <mark>T</mark>asks",
  "shortcutMnemonicGoLeads": "<mark>G</mark>o to <mark>L</mark>eads",
  "shortcutMnemonicGoMessaging": "<mark>G</mark>o to <mark>M</mark>essaging",
  "shortcutMnemonicCreateAppointment": "<mark>C</mark>reate <mark>A</mark>ppointment",
  "shortcutMnemonicCreatePatient": "<mark>C</mark>reate <mark>P</mark>atient",
  "shortcutMnemonicCreateLead": "<mark>C</mark>reate <mark>L</mark>ead",
  "shortcutMnemonicCreateTask": "<mark>C</mark>reate <mark>T</mark>ask",
  "shortcutSequenceThen": "rồi",
  "featureComingSoon": "{{feature}} sẽ sớm có mặt.",
  "accountSettings": "Tài khoản",
  "welcomeUser": "Hi, {{name}}",
  "roles": {
    "super_admin": "Super Admin",
    "admin": "Quản trị viên",
    "member": "Thành viên"
  },
  "toggleSidebar": "Ẩn/hiện menu",
  "showSidebar": "Hiện menu",
  "hideSidebar": "Ẩn menu",
  "collapseNav": "Thu gọn menu",
  "expandNav": "Mở rộng menu",
  "clockInShortcut": "Chấm công",
  "globalSearch": "Tìm kiếm",
  "globalSearchPlaceholder": "Tìm hoặc chạy lệnh…",
  "globalSearchShortcut": "{{shortcut}}",
  "globalSearchHint": "Nhập ít nhất 2 ký tự để tìm kiếm",
  "globalSearchEmpty": "Chọn hành động hoặc gõ để tìm",
  "globalSearchNoResults": "Không tìm thấy kết quả",
  "globalSearchNoMatch": "Không có hành động hoặc kết quả phù hợp",
  "globalSearchSectionError": "Không tải được nhóm này",
  "globalSearchPatients": "Bệnh nhân",
  "globalSearchLeads": "Lead",
  "globalSearchAppointments": "Lịch hẹn",
  "globalSearchTasks": "Task",
  "globalSearchActions": "Hành động",
  "globalSearchGo": "Đi tới",
  "globalSearchRecent": "Gần đây",
  "globalSearchRecentEmpty": "Chưa có lịch sử gần đây",
  "globalSearchResults": "Kết quả",
  "globalSearchFooterNavigate": "để điều hướng",
  "globalSearchFooterStepAll": "để duyệt cả hành động",
  "globalSearchFooterColumns": "để đổi cột",
  "globalSearchFooterSelect": "để chọn",
  "globalSearchFooterClose": "để đóng",
  "globalSearchFooterOpen": "để mở",
  "globalSearchPatientSummary": "Tóm tắt",
  "globalSearchPatientSummaryNextAppointment": "Hẹn tới",
  "globalSearchPatientSummaryOutstanding": "Công nợ",
  "globalSearchPatientSummaryEmpty": "Chọn bệnh nhân để xem tóm tắt",
  "globalSearchPatientSummaryNoAppointment": "Chưa có lịch hẹn",
  "globalSearchPatientSummaryError": "Không tải được tóm tắt",
  "spotlightCreateAppointment": "Tạo lịch hẹn",
  "spotlightCreatePatient": "Tạo bệnh nhân",
  "spotlightCreateLead": "Tạo lead",
  "spotlightCreateTask": "Tạo task",
  "spotlightCreateProject": "Tạo dự án",
  "spotlightCreateExpense": "Tạo chi phí",
  "spotlightCreateAdvanceRequest": "Xin tạm ứng",
  "spotlightGoDashboard": "Mở tổng quan",
  "spotlightGoPatients": "Danh sách bệnh nhân",
  "spotlightGoLeads": "Danh sách lead",
  "spotlightGoAppointments": "Lịch hẹn (calendar)",
  "spotlightGoTasks": "Danh sách task",
  "spotlightGoProjects": "Danh sách dự án",
  "spotlightGoKpi": "Phiếu KPI",
  "spotlightGoMyKpi": "KPI của tôi",
  "spotlightGoPayments": "Thanh toán",
  "spotlightGoExpenses": "Phiếu chi",
  "spotlightGoStaff": "Nhân sự",
  "spotlightGoReports": "Báo cáo",
  "spotlightCmdAppointmentsToday": "Lịch hẹn hôm nay",
  "spotlightCmdAppointmentsThisWeek": "Lịch hẹn tuần này",
  "spotlightCmdMyTasks": "Task của tôi",
  "spotlightCmdOverdueTasks": "Task quá hạn",
  "spotlightCmdTreatmentPlans": "Kế hoạch điều trị",
  "spotlightCtxCreateAppointment": "Tạo lịch hẹn",
  "spotlightCtxCreateAppointmentToday": "Tạo lịch hôm nay",
  "spotlightCtxCreateTask": "Tạo task",
  "allClinics": "Tất cả phòng khám",
  "clinic": "Phòng khám",
  "switchClinic": "Chuyển phòng khám",
  "createNewClinic": "Tạo phòng khám mới",
  "manageClinics": "Quản lý phòng khám",
  "clinicSettings": "Cài đặt phòng khám",
  "clinicSettingsAria": "Cài đặt phòng khám {{name}}",
  "today": "Hôm nay",
  "day": "Ngày",
  "week": "Tuần",
  "month": "Tháng",
  "calendarPeriod": "Chế độ xem lịch",
  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} trong {{count}}",
    "moreThan": "hơn {{to}}"
  },
  "table": {
    "expandRow": "Xem chi tiết",
    "collapseRow": "Thu gọn chi tiết",
    "expandGroup": "Hiện dòng",
    "collapseGroup": "Ẩn dòng",
    "columns": "Cột",
    "resetColumns": "Đặt lại",
    "moveColumnUp": "Đưa lên",
    "moveColumnDown": "Đưa xuống",
    "columnLayoutSaveFailed": "Không lưu được thiết lập cột",
    "customizeColumns": "Tùy chỉnh cột",
    "hideAllColumns": "Ẩn tất cả",
    "showAllColumns": "Hiện tất cả",
    "dragColumn": "Kéo để đổi chỗ",
    "total": "Tổng"
  },
  "unsupportedResolution": {
    "title": "Ứng dụng không hỗ trợ độ phân giải này!",
    "description": "Độ phân giải trình duyệt hiện tại không được hỗ trợ. Vui lòng thu nhỏ (zoom out) để tiếp tục dùng {{brand}}.",
    "suggestion": "Chúng tôi gợi ý dùng cách sau",
    "macOs": "MAC OS",
    "windows": "WINDOWS",
    "command": "Command",
    "ctrl": "CTRL"
  },
  "filters": {
    "title": "Bộ lọc",
    "apply": "Áp dụng",
    "reset": "Đặt lại"
  },

  "savedViews": {
    "menuLabel": "View",
    "defaultViewLabel": "Mặc định",
    "customViewLabel": "Tùy chỉnh",
    "activeTooltip": "View: {{name}}",
    "saveCurrent": "Lưu chế độ xem hiện tại",
    "saveTitle": "Lưu view",
    "rename": "Đổi tên",
    "renameTitle": "Đổi tên view",
    "delete": "Xóa",
    "deleteTitle": "Xóa view",
    "deleteConfirm": "Xóa view \"{{name}}\"? Hành động này không thể hoàn tác.",
    "nameLabel": "Tên view",
    "namePlaceholder": "Nhập tên view",
    "pin": "Ghim",
    "unpin": "Bỏ ghim",
    "setOpenOnLoad": "Dùng khi mở trang",
    "unsetOpenOnLoad": "Bỏ dùng khi mở trang",
    "openOnLoadBadge": "Mở khi vào",
    "empty": "Chưa có chế độ xem đã lưu",
    "validation": {
      "nameRequired": "Vui lòng nhập tên view"
    },
    "toasts": {
      "applied": "Đã áp dụng view",
      "saved": "Đã lưu view",
      "savedWithOpenOnLoad": "Đã lưu view và dùng khi mở trang",
      "renamed": "Đã đổi tên view",
      "deleted": "Đã xóa view",
      "openOnLoadSet": "Đã đặt dùng khi mở trang",
      "openOnLoadUnset": "Đã bỏ dùng khi mở trang",
      "saveFailed": "Không lưu được view",
      "updateFailed": "Không cập nhật được view",
      "deleteFailed": "Không xóa được view"
    }
  },

  "importExport": {
    "errors": {
      "IMPORT_FILE_REQUIRED": "Vui lòng chọn file CSV hoặc Excel.",
      "IMPORT_FILE_TOO_LARGE": "File vượt quá dung lượng cho phép.",
      "IMPORT_FILE_EMPTY": "File trống hoặc không đọc được.",
      "IMPORT_NO_DATA_ROWS": "File không có dòng dữ liệu.",
      "IMPORT_TOO_MANY_ROWS": "File vượt quá {{max}} dòng.",
      "IMPORT_MISSING_COLUMNS": "Thiếu cột bắt buộc: {{columns}}.",
      "IMPORT_INVALID_FILE_TYPE": "Chỉ nhận file CSV hoặc Excel (.xlsx).",
      "IMPORT_UNREADABLE_FILE": "Không đọc được file. Hãy lưu lại dạng CSV UTF-8 hoặc Excel.",
      "IMPORT_VALIDATION_FAILED": "File còn lỗi, chưa nhập được.",
      "IMPORT_COLUMN_MAP_INVALID": "Bảng ghép cột không hợp lệ.",
      "IMPORT_COLUMN_MAP_UNKNOWN_FIELD": "Trường không hỗ trợ khi import: {{field}}.",
      "IMPORT_COLUMN_MAP_UNKNOWN_SOURCE": "Không tìm thấy cột {{column}} trong file.",
      "IMPORT_COLUMN_MAP_DUPLICATE": "Cột {{column}} đang được ghép cho nhiều trường.",
      "EXPORT_TOO_LARGE": "Quá nhiều dòng để xuất (tối đa {{max}}). Hãy thu hẹp bộ lọc.",
      "EXPORT_DATE_INVALID": "Khoảng ngày xuất không hợp lệ."
    },
    "columnMap": {
      "title": "Ghép cột",
      "hint": "Chọn cột trong file tương ứng với từng trường. Tên cột không cần giống file mẫu.",
      "field": "Trường hệ thống",
      "source": "Cột trong file",
      "sample": "Dữ liệu mẫu",
      "skip": "Không nhập",
      "check": "Kiểm tra",
      "subjectHint": "Cần ghép ít nhất một trong mã bệnh nhân hoặc SĐT lead.",
      "incomplete": "Ghép đủ các trường bắt buộc rồi bấm Kiểm tra.",
      "inspecting": "Đang đọc cột trong file…"
    }
  },

  "routeError": {
    "title": "Đã xảy ra lỗi",
    "body": "Không tải được trang này. Bạn có thể thử tải lại hoặc quay về trang chủ.",
    "retry": "Tải lại",
    "home": "Về trang chủ"
  }
}
